import type { OrderStatus } from '../types';

export const STATUS_COLORS: Record<OrderStatus, string> = {
  NEW: 'red',
  PAYMENT_PENDING: 'orange',
  PAID: 'blue',
  LYRICS_GENERATING: 'cyan',
  LYRICS_REVIEW: 'purple',
  SUNO_GENERATING: 'geekblue',
  QUALITY_CHECK: 'gold',
  DELIVERY: 'lime',
  COMPLETED: 'green',
  CANCELLED: 'default',
  REFUNDED: 'magenta',
  ERROR: 'red',
  DLQ: 'volcano'
};

export const STATUS_LABELS: Record<OrderStatus, string> = {
  NEW: 'Новий',
  PAYMENT_PENDING: 'Очікує оплати',
  PAID: 'Оплачено',
  LYRICS_GENERATING: 'Генерація тексту',
  LYRICS_REVIEW: 'Перевірка тексту',
  SUNO_GENERATING: 'Генерація пісні',
  QUALITY_CHECK: 'Перевірка якості',
  DELIVERY: 'Доставка',
  COMPLETED: 'Виконано',
  CANCELLED: 'Скасовано',
  REFUNDED: 'Повернуто',
  ERROR: 'Помилка',
  DLQ: 'Критична помилка'
};

export const CHANNEL_LABELS = {
  viber: 'Viber',
  telegram: 'Telegram',
  whatsapp: 'WhatsApp'
};

export const CHANNEL_COLORS = {
  viber: 'purple',
  telegram: 'blue',
  whatsapp: 'green'
};

export const IN_PROGRESS_STATES: OrderStatus[] = [
  'PAYMENT_PENDING',
  'PAID',
  'LYRICS_GENERATING',
  'LYRICS_REVIEW',
  'SUNO_GENERATING',
  'QUALITY_CHECK',
  'DELIVERY'
];
